import { r as registerInstance, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsInteractionBlockCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-interaction-block{cursor:pointer;display:block;max-width:100%;margin-bottom:0.75rem}.fds-interaction-block .fds-interaction-block__inner{box-sizing:border-box;cursor:pointer;appearance:none;text-align:left;width:100%;display:flex;align-items:center;background-color:white;padding:calc(1rem - 2px);padding-right:calc(1rem - 0.5rem);color:#1D69C2;box-shadow:0 4px 16px 0 #C7E4FD;border-radius:16px;text-decoration:none;border:2px solid transparent;transition:box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, background-color 0.2s ease-in-out}.fds-interaction-block .fds-interaction-block__inner__content{display:flex;flex-direction:row;width:100%;flex:1}.fds-interaction-block .fds-interaction-block__inner__content__header{display:inherit}.fds-interaction-block .fds-interaction-block__inner__content__header .header--3{flex:1;font-family:Raleway, Arial, sans-serif;font-size:1.125rem;line-height:1.335;letter-spacing:0}.fds-interaction-block .fds-interaction-block__inner__icon{display:flex;align-items:center;justify-content:center;width:24px;height:24px;margin-right:0.75rem;color:#3B87DD}.fds-interaction-block .fds-interaction-block__inner__meta{display:block;color:rgba(0, 0, 0, 0.795);margin-top:0.5rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:normal;font-size:1rem;line-height:1.5;letter-spacing:0}.fds-interaction-block .fds-interaction-block__inner__arrow{margin-left:0.75rem;color:#3B87DD}.fds-interaction-block .fds-interaction-block__inner:hover,.fds-interaction-block .fds-interaction-block__inner:focus,.fds-interaction-block .fds-interaction-block__inner--hover,.fds-interaction-block .fds-interaction-block__inner--focus{border-color:#3B87DD}.fds-interaction-block .fds-interaction-block__inner:active,.fds-interaction-block .fds-interaction-block__inner--active{box-shadow:none;background-color:rgba(12, 72, 153, 0.0475);border-color:transparent}.fds-interaction-block *:last-child{margin-bottom:0 !important}.fds-interaction-block.fds-interaction-block--no-interactive .fds-interaction-block__inner{cursor:auto}.fds-interaction-block.fds-interaction-block--no-interactive .fds-interaction-block__inner:hover,.fds-interaction-block.fds-interaction-block--no-interactive .fds-interaction-block__inner:focus{border-color:transparent}.fds-interaction-block.fds-interaction-block--no-interactive .fds-interaction-block__inner:active{box-shadow:0 4px 16px 0 #C7E4FD;background-color:white;border-color:transparent}.fds-interaction-block.fds-interaction-block--disabled .fds-interaction-block__inner{cursor:not-allowed;box-shadow:none}.fds-interaction-block.fds-interaction-block--disabled .fds-interaction-block__inner:hover,.fds-interaction-block.fds-interaction-block--disabled .fds-interaction-block__inner:focus{border-color:transparent}.fds-interaction-block.fds-interaction-block--disabled .fds-interaction-block__inner__content__header{color:rgba(0, 0, 0, 0.895)}.fds-interaction-block.fds-interaction-block--disabled .fds-interaction-block__inner__icon{color:rgba(0, 0, 0, 0.895)}.fds-interaction-block.fds-interaction-block--disabled .fds-interaction-block__inner__arrow{display:none}.fds-interaction-block.fds-interaction-block__noArroworIcon{padding-right:calc(1rem - 2px)}.fds-interaction-block.fds-interaction-block__noArroworIcon .fds-interaction-block__inner{padding-right:calc(1rem - 2px)}.fds-interaction-block.fds-interaction-block__noArroworIcon .fds-interaction-block__inner__content__header{margin-bottom:0.5rem}";

const FdsInteractionBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.state = 'none';
    this.label = undefined;
    this.arrow = true;
    this.disabled = false;
    this.download = undefined;
    this.href = undefined;
    this.target = undefined;
    this.rel = undefined;
    this.icon = undefined;
    this.interactive = true;
  }
  // componentWillLoad() {
  //   this.handleDisabled()
  // }
  // /**
  //  * Handle the disable state of the slotted element.
  //  */
  // private handleDisabled () {
  //   // const link = this.el.getElementsByTagName('a')
  //   const button = this.el.getElementsByTagName('button')
  //   // if (link) link[0].disabled = this.disabled
  //   if (button) button[0].disabled = this.disabled
  // }
  /**
   * If the icon prop exists, then show the icon.
   */
  setIcon() {
    if (this.icon) {
      return h("span", { class: "fds-interaction-block__inner__icon" }, h("fds-icon", { name: this.icon }));
    }
    else {
      return null;
    }
  }
  /**
   * If the arrow attribute is set to `true`, then show it.
   */
  setArrow() {
    if (this.arrow) {
      return (h("span", { class: "fds-interaction-block__inner__arrow" }, h("fds-icon", { name: "arrowRight" })));
    }
    else {
      return null;
    }
  }
  /**
   * If the interaction block has any content, then render the content section
   */
  setContent() {
    if (this.el.children.length > 0) {
      return h("span", { class: "fds-interaction-block__inner__meta" }, h("slot", null));
    }
    else {
      return null;
    }
  }
  /**
   * Prevent default (disable) a tag
   */
  handleClick(e, TagType) {
    if (TagType === 'a' && this.disabled) {
      e.preventDefault();
    }
    else if (this.href) {
      window.location.href = this.href;
    }
  }
  render() {
    const { state, href, target, rel, disabled, interactive } = this;
    // If not interactive the tag type should be a div, if interactive then check if there's a
    const TagType = interactive ? (href === undefined ? 'button' : 'a') : 'div';
    const attrs = (TagType === 'button' ? { type: 'button' } : { download: this.download, href, rel, target });
    const setContentMargin = !this.arrow && !this.icon && this.el.children.length > 0;
    function setClasses() {
      const classArr = [
        (disabled ? 'fds-interaction-block--disabled' : null),
        // (state && state !== 'none' ? `fds-interaction-block--${state}` : null),
        (setContentMargin ? 'fds-interaction-block__noArroworIcon' : null)
      ];
      var classList = classArr.filter(val => val !== null);
      return classList.join(' ');
    }
    function setStateClass() {
      return state && state !== 'none' ? `fds-interaction-block__inner--${state}` : null;
    }
    return (h(Host, { "aria-disabled": disabled ? 'true' : null, class: `fds-interaction-block ${setClasses()}` }, h(TagType, Object.assign({}, attrs, { class: `fds-interaction-block__inner ${setStateClass()}`, onClick: (e) => this.handleClick(e.preventDefault(), TagType), disabled: disabled && TagType === 'button' ? true : false }), h("div", { class: "fds-interaction-block__inner__content" }, this.setIcon(), h("div", null, h("span", { class: "fds-interaction-block__inner__content__header" }, h("span", { class: "header--3" }, this.label)), this.setContent())), this.setArrow())));
  }
  get el() { return getElement(this); }
};
FdsInteractionBlock.style = fdsInteractionBlockCss;

export { FdsInteractionBlock as fds_interaction_block };
